/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 15:03:56
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-23 16:39:27
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/Text/index.tsx
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-16 15:37:46
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ProductCarousel/index.tsx
 */
import React from 'react';

import _Text from 'src/components/Modules/Text';

import ContentGroupHOC from '../HOC';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { compose } from 'redux';

const Text = (props) => {
  const {
    staticData,
    handleOnStaticsChange,
    specificError,
    linkSet,
    extraProps,
    draggableId,
    disabled,
    allDisabled,
  } = props || {};
  const h1TagUuid = (extraProps || {}).h1TagUuid;
  const disableTagCheckbox = h1TagUuid ? draggableId !== h1TagUuid : false;

  return (
    <_Text
      disableTagCheckbox={disableTagCheckbox}
      linkSet={linkSet}
      staticData={staticData}
      onStaticChange={handleOnStaticsChange}
      specificError={specificError}
      disabled={disabled || allDisabled}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(Text);
